module.exports = __webpack_public_path__ + "img/automotive-careers.d8dbc93d.jpg";